import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "startTime", "endDate", "endTime"]

  combineDates(event) {
    event.preventDefault()
    
    try {
      // Get form values
      const startDate = this.startDateTarget.value
      const startTime = this.startTimeTarget.value || "00:00"
      const endDate = this.endDateTarget.value
      const endTime = this.endTimeTarget.value || "00:00"
      
      // Validate required fields
      if (!startDate || !endDate) {
        return false
      }
      
      // Create date objects with the current timezone
      const startDateTime = this.createDateWithTime(startDate, startTime)
      const endDateTime = this.createDateWithTime(endDate, endTime)
      
      // Validate dates
      if (isNaN(startDateTime.getTime())) {
        return false
      }
      if (isNaN(endDateTime.getTime())) {
        return false
      }
      
      // Validate date order
      if (endDateTime < startDateTime) {
        return false
      }
      
      // Update hidden fields
      const form = event.currentTarget
      const startDateField = form.querySelector('[name="absence_record[start_date]"]')
      const endDateField = form.querySelector('[name="absence_record[end_date]"]')
      
      if (!startDateField || !endDateField) {
        return false
      }
      
      // Format dates as ISO strings
      startDateField.value = startDateTime.toISOString()
      endDateField.value = endDateTime.toISOString()
      
      // Submit the form
      form.submit()
    } catch (error) {
      console.error("Error combining dates:", error)
      return false
    }
  }

  createDateWithTime(date, time) {
    const [hours, minutes] = time.split(':')
    const dateObj = new Date(date)
    dateObj.setHours(parseInt(hours, 10))
    dateObj.setMinutes(parseInt(minutes, 10))
    dateObj.setSeconds(0)
    dateObj.setMilliseconds(0)
    return dateObj
  }
}
